
// アカウント権限判断

export const RoleFlagCheck = function () {}
// 会員権限であるかどうか
RoleFlagCheck.member = function (roleFlag) {
  if (roleFlag === null || roleFlag === '' || roleFlag.length !== 5) {
    return ''
  }
  return roleFlag.charAt(0) === '1'
}

// ドライバー権限であるかどうか
RoleFlagCheck.diver = function (roleFlag) {
  if (roleFlag === null || roleFlag === '' || roleFlag.length !== 5) {
    return ''
  }
  return roleFlag.charAt(1) === '1'
}

// 一般管理者権限であるかどうか
RoleFlagCheck.generalManager = function (roleFlag) {
  if (roleFlag === null || roleFlag === '' || roleFlag.length !== 5) {
    return ''
  }
  return roleFlag.charAt(2) === '1'
}

// マスター管理者権限であるかどうか
RoleFlagCheck.masterManager = function (roleFlag) {
  if (roleFlag === null || roleFlag === '' || roleFlag.length !== 5) {
    return ''
  }
  return roleFlag.charAt(3) === '1'
}

// 交通事業者権限であるかどうか
RoleFlagCheck.transport = function (roleFlag) {
  if (roleFlag === null || roleFlag === '' || roleFlag.length !== 5) {
    return ''
  }
  return roleFlag.charAt(4) === '1'
}

// マスター権限
RoleFlagCheck.roles = function (roleFlag) {
  if (roleFlag === null || roleFlag === '' || roleFlag.length !== 5) {
    return ''
  }
  let role = ''
  if (roleFlag.charAt(0) === '1') {
    role = role + '会員、'
  }
  if (roleFlag.charAt(1) === '1') {
    role = role + 'ドライバー、'
  }
  if (roleFlag.charAt(2) === '1') {
    role = role + '一般管理者、'
  }
  if (roleFlag.charAt(3) === '1') {
    role = role + '管理マスター、'
  }
  return role.substring(0, role.lastIndexOf('、'))
}



// WEBPACK FOOTER //
// ./src/utils/RoleFlagCheck.js